import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

export default class PageContact extends Component {
	  	
	render () {
		
		let post 	= this.props.post;
		let block 	= this.props.block;
				
		if (block) {
						
		    return (
			    
				<div className="c-page__block c-page__block--splash">
					
					<div className="c-splash">
					
						<div className="c-splash__inner">
														
							{block.src &&
								<Image src={block.src} srcset={block.srcset} />
							}
							
							{block.video &&
								<Cinemagraph src={block.video} />
							}
						
						</div>
												
						<div className="c-splash__tagline">
							<h2 className="c-splash__tagline__text" dangerouslySetInnerHTML={{__html:'Architecture and Interiors'}}></h2>
						</div>


						<div className="c-splash__text">
												
							<div className="scope-text scope-text--footer">
		    					{post.ftr_office.map((office,i) =>
									{
										return (
											<>
						    					{office.ftr_address &&
							    					<h4 dangerouslySetInnerHTML={ {__html: office.ftr_address}}></h4>
						    					}
						    					{office.ftr_direction_url &&
							    					<p dangerouslySetInnerHTML={ {__html: '<a href="' + office.ftr_direction_url + '">Get Directions</a>'}}></p>
						    					}
						    					{office.ftr_phone_number && office.ftr_phone_number_url &&
							    					<>
							    						<h4 dangerouslySetInnerHTML={ {__html: 'Phone'}}></h4>
							    						<p dangerouslySetInnerHTML={ {__html: '<a class="no-underline" href="tel:' + office.ftr_phone_number_url + '">' + office.ftr_phone_number + '</a>'}}></p>
							    					</>
						    					}
						    				</>
					    				)
					    			}
								)}
		    					{post.ftr_email &&
			    					<>
			    						<h4 dangerouslySetInnerHTML={ {__html: 'Email'}}></h4>
										<p dangerouslySetInnerHTML={ {__html: '<a class="no-underline" href="mailto:' + post.ftr_email + '">' + post.ftr_email + '</a>'}}></p>
			    					</>
		    					}
		    					{post.ftr_instagram_url &&
			    					<>
		    							<h4 dangerouslySetInnerHTML={ {__html: 'Social'}}></h4>
										<p dangerouslySetInnerHTML={ {__html: '<a class="no-underline" href="' + post.ftr_instagram_url + '">Instagram</a>'}}></p>
									</>
		    					}
		    					{post.rego_heading && post.rego_text &&
			    					<>
		    							<h4 dangerouslySetInnerHTML={ {__html: post.rego_heading}}></h4>
										<p dangerouslySetInnerHTML={ {__html: post.rego_text}}></p>
									</>
			    					
		    					}
		    				</div>
						
						</div>
						
					</div>	
					
				</div>
				
			)
			
		} else {
			
			return null;
		
		}
	}
}
